import { atom } from "jotai";

import { paneAtom } from "./pane";
import { addressBookAtom } from "./state";

export const isVisibleAtom = atom(
  (get) => get(addressBookAtom).isVisible,
  (_get, set, value: boolean) => {
    set(addressBookAtom, (draft) => {
      draft.isVisible = value;
    });
  },
);

export const showAtom = atom(null, (_get, set) => {
  set(isVisibleAtom, true);
});

export const hideAtom = atom(null, (_get, set) => {
  set(isVisibleAtom, false);

  // Next opening starts on the list again
  set(paneAtom, "list");
});

export const toggleAtom = atom(null, (get, set) => {
  const current = get(isVisibleAtom);
  set(isVisibleAtom, !current);
});
